import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=af11a5da&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=af11a5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af11a5da",
  null
  
)

export default component.exports